export const trimSpace = (string) => {
    return string.replace(/^\s+/, "")
}